{
  "version": 1,
  "asset_id": "332c7d6e-eb59-43ea-9149-a6da8d108f27",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/332c7d6e-eb59-43ea-9149-a6da8d108f27/airtechpro-gsc-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/332c7d6e-eb59-43ea-9149-a6da8d108f27/airtechpro-gsc-1280.webp",
  "original_filename": "airtechpro-gsc-1280.webp",
  "size": 50438,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:47Z"
}
